import { render, staticRenderFns } from "./VariationCrossSelling.vue?vue&type=template&id=1bd31c39&"
import script from "./VariationCrossSelling.vue?vue&type=script&lang=js&"
export * from "./VariationCrossSelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero-50965/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd31c39')) {
      api.createRecord('1bd31c39', component.options)
    } else {
      api.reload('1bd31c39', component.options)
    }
    module.hot.accept("./VariationCrossSelling.vue?vue&type=template&id=1bd31c39&", function () {
      api.rerender('1bd31c39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/VariationCrossSelling.vue"
export default component.exports